import React from "react";
import { Eye, HardHat, Trash2 } from "lucide-react";

function Item({ v, active, count, onPick, onDelete }) {
  return (
    <div className={`group flex items-center rounded transition-colors ${active ? "bg-norea-primary/10 text-norea-primary" : "hover:bg-norea-surfaceHover text-norea-text"}`}>
      <button onClick={onPick} className="flex-1 flex items-center justify-between gap-2 text-left text-[13px] px-2 py-1.5 min-w-0" data-testid={`sav-view-${v.id}`}>
        <span className="truncate">{v.name}</span><span className="text-[11px] text-norea-textMuted tabular-nums" data-testid={`sav-view-count-${v.id}`}>{count}</span>
      </button>
      {onDelete && <button onClick={onDelete} className="p-1 mr-1 opacity-0 group-hover:opacity-100 text-norea-textMuted hover:text-red-700 transition-opacity" data-testid={`sav-view-delete-${v.id}`}><Trash2 className="w-3 h-3" /></button>}
    </div>
  );
}

const Title = ({ icon: Icon, children }) => <div className="text-[10px] uppercase tracking-wider font-semibold text-norea-textMuted px-2 mt-4 mb-1 inline-flex items-center gap-1">{Icon && <Icon className="w-3 h-3" />}{children}</div>;

export default function SavViewsSidebar({ system, custom, activeId, counts, onPick, onDelete }) {
  const main = system.filter((v) => !v.group);
  const subs = system.filter((v) => v.group === "subcontractor");
  return (
    <aside className="w-48 shrink-0" data-testid="sav-views">
      <Title>Vues</Title>
      {main.map((v) => <Item key={v.id} v={v} active={activeId === v.id} count={counts[v.id]} onPick={() => onPick(v)} />)}
      <Title icon={Eye}>Vues de l'équipe</Title>
      {custom.length === 0 && <div className="text-[11px] italic text-norea-textMuted px-2">Filtrez puis « Enregistrer comme vue ».</div>}
      {custom.map((v) => <Item key={v.id} v={v} active={activeId === v.id} count={counts[v.id]} onPick={() => onPick(v)} onDelete={() => onDelete(v)} />)}
      <Title icon={HardHat}>Par sous-traitant</Title>
      {subs.map((v) => <Item key={v.id} v={v} active={activeId === v.id} count={counts[v.id]} onPick={() => onPick(v)} />)}
    </aside>
  );
}
